var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173,
    height: 167,
    viewBox: "15 10 145 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #c6c6c6;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke: #606060;\r\n        stroke-width: 1.1px;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(257.762 -115.937)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    className: "cls-1",
    width: 173,
    height: 167,
    transform: "translate(-257.762 115.937)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    className: "cls-2",
    width: 86.7,
    height: 81.983,
    transform: "translate(-214.762 138.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-2",
    d: "M0,5.752l1.531-.141L3.062,5.2l1.531-.636,1.531-.8,1.531-.889,1.531-.889,1.531-.8L12.248.549,13.779.141,15.31,0l1.531.141,1.531.409,1.531.636,1.531.8,1.531.889,1.531.889,1.531.8,1.531.636,1.531.409,1.531.141,1.531-.141L33.682,5.2l1.531-.636,1.531-.8,1.531-.889,1.531-.889,1.531-.8L42.867.549,44.4.141,45.929,0,47.46.141l1.531.409,1.531.636,1.531.8,1.531.889,1.531.889,1.531.8,1.531.636,1.531.409,1.531.141,1.531-.141L64.3,5.2l1.531-.636,1.531-.8,1.531-.889,1.531-.889,1.531-.8L73.487.549,75.018.141,76.549,0,78.08.141l1.531.409,1.531.636,1.531.8,1.531.889,1.531.889,1.531.8L88.8,5.2l1.531.409,1.531.141,1.531-.141L94.921,5.2l1.531-.636,1.531-.8,1.531-.889,1.531-.889,1.531-.8,1.531-.636,1.531-.409L107.169,0,108.7.141l1.531.409,1.531.636,1.531.8,1.531.889,1.531.889,1.531.8,1.531.636,1.531.409",
    transform: "translate(-110.293 224.54) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-3",
    d: "M1-10.248l1.531-.141L4.062-10.8l1.531-.636,1.531-.8,1.531-.889,1.531-.889,1.531-.8,1.531-.636,1.531-.409L16.31-16l1.531.141,1.531.409,1.531.636,1.531.8,1.531.889,1.531.889,1.531.8,1.531.636,1.531.409,1.531.141,1.531-.141,1.531-.409,1.531-.636,1.531-.8,1.531-.889,1.531-.889,1.531-.8,1.531-.636,1.531-.409L46.929-16l1.531.141,1.531.409,1.531.636,1.531.8,1.531.889,1.531.889,1.531.8,1.531.636,1.531.409,1.531.141,1.531-.141L65.3-10.8l1.531-.636,1.531-.8,1.531-.889,1.531-.889,1.531-.8,1.531-.636,1.531-.409L77.549-16l1.531.141,1.531.409,1.531.636,1.531.8,1.531.889,1.531.889,1.531.8L89.8-10.8l1.531.409,1.531.141,1.531-.141,1.531-.409,1.531-.636,1.531-.8,1.531-.889,1.531-.889,1.531-.8,1.531-.636,1.531-.409L108.169-16l1.531.141,1.531.409,1.531.636,1.531.8,1.531.889,1.531.889,1.531.8,1.531.636,1.531.409",
    transform: "translate(-218.512 234.788)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    className: "cls-3",
    width: 9,
    height: 33,
    transform: "translate(-127.762 205.938)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    className: "cls-3",
    width: 10,
    height: 26,
    transform: "translate(-117.762 204.938)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    className: "cls-3",
    width: 8,
    height: 23,
    transform: "translate(-232.762 204.938)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    className: "cls-3",
    width: 10,
    height: 31,
    transform: "translate(-224.762 204.938)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    className: "cls-4",
    transform: "translate(-225.191 128.444)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 107.531,
    height: 140.475
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.55,
    y: 0.55,
    width: 106.431,
    height: 139.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    className: "cls-4",
    transform: "translate(-215.814 137.297)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 88.776,
    height: 122.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.55,
    y: 0.55,
    width: 87.676,
    height: 121.67
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/Wave.c04108349ac4c56e51e0c4ee104f8f3f.svg";
export { ForwardRef as ReactComponent };